module.exports = "/images/app-external-bg.0c0c77243782c6af38fd7ebacad004ea.png";